<app-collapse [rounded]="true" [collapse]="collapsePortArrivalDetails"
              [showOnLoad]="context.incomingMovementRelevantForAgent()" [animateOnLoad]="true"
              [renderWhenCollapsed]="true">
  <!-- SUMMARY -->
  <!-- Port arrival header -->
  <div class="row p-3 g-0 align-items-center">
    <div class="col">
      <!-- Display the pilot station and entry point -->
      @if (!context.visit.orderNauticalServices) {
        <span class="fw-bold text-dark">{{
            context.visit.visitDeclaration.portVisit.entryPoint ?
              context.visit.visitDeclaration.portVisit.entryPoint.name : 'Port arrival'
          }}</span>
      }
      @if (context.visit.orderNauticalServices) {
        @if (context.visit.visitDeclaration.portVisit.pilotStation || context.visit.visitDeclaration.portVisit.entryPoint) {
          @if (context.visit.incomingTidalWindowStatus; as status) {
            @if (status.tidalShip) {
              <span class="fa text-info fa-fw me-2"
                    title="Tidal restricted"
                    [ngClass]="status.tidalWindowType === 'ASTRO' ? 'fa-satellite-dish' : 'fa-water'"></span>
            }
          }
          <span class="fw-bold text-dark">
            {{ context.visit.visitDeclaration.portVisit.pilotStation?.name }}
            @if (context.visit.visitDeclaration.portVisit.entryPoint; as entryPoint) {
              <span> -
                {{ entryPoint.name }}</span>
            }
          </span>
        } @else {
          <span class="fw-bold text-dark">
            Port arrival
          </span>
        }
      }
      @if (context.visit.visitDeclaration.portVisit.portEntry && context.visit.visitDeclaration.portVisit.portEntry.earliestTimeOfPortEntry) {
        <span
          class="ms-3 text-muted">
          Earliest time of port entry:
          {{ asTime(context.visit.visitDeclaration.portVisit.portEntry.earliestTimeOfPortEntry) }},
          {{ asDate(context.visit.visitDeclaration.portVisit.portEntry.earliestTimeOfPortEntry, "") }}
        </span>
      }
    </div>
    <div class="col-auto d-none d-md-block text-dark">
      <!-- Placeholder icons -->
    </div>
  </div>
</app-collapse>
<ng-template #collapsePortArrivalDetails>
  <div class="collapse">
    <div class="border rounded-bottom p-3 mb-3">
      <app-port-entry-tab></app-port-entry-tab>
    </div>
  </div>
</ng-template>
